import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { SocialPeriodDays } from '../promote/socialPeriod';
import { SocialPeriodPicker } from './SocialPeriodPicker';
import { socialPeriodRange } from './socialPeriodDates';
import { socialMessages as messages } from './socialMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet per screen; each part of the screen uses its own slice of it */
import styles from './Social.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SocialPeriodControlProps {
  days: SocialPeriodDays;
  historyDaysLimit: number;
  onChange: (days: SocialPeriodDays) => void;
}

/** The period picker with its dates under it (design your-intelligence g1). */
const SocialPeriodControlComponent: React.FC<SocialPeriodControlProps> = ({ days, historyDaysLimit, onChange }) => {
  const intl = useIntl();
  const dates = useMemo(() => {
    const { from, to } = socialPeriodRange(days);
    const format = (day: string) => intl.formatDate(day, { day: 'numeric', month: 'short', timeZone: 'UTC' });
    return intl.formatMessage(messages.periodDates, { start: format(from), end: format(to) });
  }, [days, intl]);

  return (
    <div className={styles.periodControl}>
      <SocialPeriodPicker days={days} historyDaysLimit={historyDaysLimit} onChange={onChange} />
      <div className={styles.periodDates}>{dates}</div>
    </div>
  );
};

export const SocialPeriodControl = TypedMemo(SocialPeriodControlComponent);
